module.exports = __webpack_public_path__ + "img/Valentines.acd55028.png";